module.exports = __webpack_public_path__ + "static/media/house_lannister.63353d14.png";